import React, { useState, useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { useListVals } from 'react-firebase-hooks/database'
import { NotificationDb } from '../../firebaseConfig'
import { useHistory } from 'react-router-dom'
import { COLORS } from '../../styles/theme'
import TimeAgo from 'javascript-time-ago'
import ReactTimeAgo from 'react-time-ago'
import enMY from 'javascript-time-ago/locale/en-MY'
import { Loader } from '../shared/Loader'
import { HiMiniArrowLeft, HiMiniArrowRight } from 'react-icons/hi2'
import {  } from 'react-icons/hi2'
TimeAgo.addDefaultLocale(enMY)

const StyledModal = styled(Modal)`
  text-align: left;

  .notification-list {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10.25px);
    border-radius: 10px;
    padding: 32px 36px;
  }
  .modal-content {
    position: relative;
    background-color: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(25px);
    border: none;
    border-radius: 8px;
    margin-bottom: 24px;
    padding: 40px;

    .modal-header {
      display: flex;
      justify-content: normal;
      align-items: center;
      gap: 24px;
      color: var(--blue-01);
      border: none;

      .modal-title {
        flex: 1;
        font-size: 32px;
        font-weight: 700;
        text-align: center;
      }

      div[role='button'] {
        position: absolute;
        gap: 8px;
        font-size: 24px;
        font-weight: 700;
        cursor: pointer;
        z-index: 20;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
  .modal-body {
    padding: 0;
    section {
      h4 {
        font-style: italic;
        font-size: 23px;
        font-weight: bold;
      }
    }
  }
  #refresh-btn {
    border: solid 1px ${COLORS.primary};
    background: #ffad2c;
    padding: 5px 10px;
    border-radius: 16px;
    margin: 36px auto;
    display: block;
  }
`
const MessageWrapper = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(8, 8, 10, 0.5);

  div.text-content {
    width: 85%;
    color: #111827;
    p {
      font-size: 20px;
      margin: 0;
    }
    small.timestamp {
      font-size: 14px;
      color: #4b5563;
      margin-bottom: 16px;
    }
  }
`
export default function NotificationModal({ showModal, hideModal }) {
  const [values, loading, error] = useListVals(NotificationDb)

  const history = useHistory()
  const [notification, setNotification] = useState(null)

  const refreshPage = () => {
    window.location.reload()
  }

  const handleRedirect = (url) => {
    hideModal()
    history.push(url)
  }

  useEffect(() => {
    if (!values) return

    const newItems = values.length - localStorage.getItem('IA_notifications')
    let updated = values
      .sort((a, b) => new Date(b.datetime) - new Date(a.datetime))
      .map((item, index) => {
        return {
          ...item,
          read: index < newItems ? false : true,
        }
      })
    setNotification(updated)
    if (values.length > localStorage.getItem('IA_notifications')) {
      localStorage.setItem('IA_notifications', values.length)
    }
  }, [loading, values])

  return (
    <StyledModal show={showModal} onHide={hideModal} size="xl" aria-labelledby="notification-modal" centered backdrop={false}>
      <Modal.Header closeButton={false}>
        <div role="button" className="d-flex align-items-center" onClick={hideModal}>
          <HiMiniArrowLeft />
          <span>Back</span>
        </div>
        <Modal.Title>Notifications</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className="notification-list">
          {loading ? (
            <Loader />
          ) : error ? (
            <button id="refresh-btn" onClick={refreshPage}>
              Connection failed. Click here to refresh.
            </button>
          ) : (
            <div>
              {notification.map((item, index) => {
                return (
                  <MessageWrapper key={`notify-${index}`} read={item.read}>
                    <div className="text-content">
                      <p>{item.message}</p>
                      <small className="d-block timestamp">{item.datetime && <ReactTimeAgo date={item.datetime} />}</small>
                    </div>
                    <div className="btn-container">
                      {item.url && (
                        <Button onClick={() => handleRedirect(item.url)} className="theme-btn">
                          <span>Enter</span>
                          <HiMiniArrowRight />
                        </Button>
                        // <div onClick={() => handleRedirect(item.url)} className="btn c-button">
                        //   <span>Enter</span>
                        // </div>
                      )}
                    </div>
                  </MessageWrapper>
                )
              })}
            </div>
          )}
        </section>
      </Modal.Body>
    </StyledModal>
  )
}
